export default __webpack_public_path__ + "static/media/fill_white.9d6b0d07.svg";